<template>
  <aside class="app-notice">
    <slot name="title"><h1>Did you know?</h1></slot>
    <slot></slot>
  </aside>
</template>

<script setup>

</script>